import React from 'react'

import { Tag } from '../tag/tag'

export const TagCheckinCheckout = ({
  isEarlyCheckin,
  isLateCheckout,
  className,
}: {
  isEarlyCheckin: boolean
  isLateCheckout: boolean
  className?: string
}) => {
  if (!isEarlyCheckin && !isLateCheckout) {
    return null
  }

  const chooseLabel = () => {
    if (isEarlyCheckin && isLateCheckout) {
      return 'Option arrivée anticipée et départ tardif'
    } else if (isEarlyCheckin) {
      return 'Option arrivée anticipée'
    } else {
      return 'Option départ tardif'
    }
  }

  return <Tag className={className} label={chooseLabel()} />
}
